import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import SignAgreement from "@/pages/SignAgreement";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Roster from "@/pages/Roster";
import Staff from "@/pages/Staff";
import Payroll from "@/pages/Payroll";
import Policies from "@/pages/Policies";
import Compliance from "@/pages/Compliance";
import VisitDetail from "@/pages/VisitDetail";
import Incidents from "@/pages/Incidents";
import Billing from "@/pages/Billing";
import FamilyPortal from "@/pages/FamilyPortal";
import FamilyAdmin from "@/pages/FamilyAdmin";
import Activity from "@/pages/Activity";
import Inbox from "@/pages/Inbox";
import Enquiries from "@/pages/Enquiries";
import Trash from "@/pages/Trash";
import Leave from "@/pages/Leave";
import Account from "@/pages/Account";
import Training from "@/pages/Training";
function Protected({ children, adminOnly, page }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <div className="h-10 w-10 rounded-full border-4 border-brand border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "family") return <Navigate to="/family" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (page && !(user.permissions || []).includes(page)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function FamilyGuard({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <div className="h-10 w-10 rounded-full border-4 border-brand border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "family") return <Navigate to="/" replace />;
  return children;
}

function ManagerFamilyGuard({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <div className="h-10 w-10 rounded-full border-4 border-brand border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (!["admin", "office", "viewer"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="bottom-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sign/:token" element={<SignAgreement />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/roster" element={<Protected page="roster"><Roster /></Protected>} />
            <Route path="/visits/:id" element={<Protected><VisitDetail /></Protected>} />
            <Route path="/incidents" element={<Protected page="incidents"><Incidents /></Protected>} />
            <Route path="/clients" element={<Protected page="clients"><Clients /></Protected>} />
            <Route path="/enquiries" element={<Protected page="enquiries"><Enquiries /></Protected>} />
            <Route path="/staff" element={<Protected page="staff"><Staff /></Protected>} />
            <Route path="/billing" element={<Protected page="billing"><Billing /></Protected>} />
            <Route path="/payroll" element={<Protected page="payroll"><Payroll /></Protected>} />
            <Route path="/families" element={<Protected page="families"><FamilyAdmin /></Protected>} />
            <Route path="/activity" element={<Protected page="activity"><Activity /></Protected>} />
            <Route path="/policies" element={<Protected page="policies"><Policies /></Protected>} />
            <Route path="/compliance" element={<Protected page="compliance"><Compliance /></Protected>} />
            <Route path="/inbox" element={<Protected page="inbox"><Inbox /></Protected>} />
            <Route path="/leave" element={<Protected page="leave"><Leave /></Protected>} />
            <Route path="/training" element={<Protected page="training"><Training /></Protected>} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
            <Route path="/trash" element={<Protected page="trash"><Trash /></Protected>} />
            <Route path="/family" element={<FamilyGuard><FamilyPortal /></FamilyGuard>} />
            <Route path="/family-preview/:clientId" element={<ManagerFamilyGuard><FamilyPortal preview /></ManagerFamilyGuard>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
